import Maintenance from './pages/Maintenance';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ContactPage from './pages/ContactPage';
import Portfolio from './pages/Portfolio';
import OngoingProjects from './pages/OngoingProjects';
import './styles/App.scss';

function App() {
  const MAINTENANCE_MODE = false;

  if (MAINTENANCE_MODE) {
    return <Maintenance />;
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <Navigation />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/ongoing-projects" element={<OngoingProjects />} />
            <Route path="*" element={<div>404 - Page Not Found</div>} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
};
export default App;